"use client";

import { useEffect } from "react";

import { createLiquidGlassController } from "@/lib/design/liquid-glass-controller";

/** Progressively enhances server-rendered material surfaces after hydration. */
export function LiquidGlassEnhancer() {
  useEffect(() => {
    let controller: ReturnType<typeof createLiquidGlassController> | null =
      null;
    let firstFrame: number | null = null;
    let secondFrame: number | null = null;
    let cancelled = false;

    const start = () => {
      firstFrame = window.requestAnimationFrame(() => {
        secondFrame = window.requestAnimationFrame(() => {
          if (!cancelled) controller = createLiquidGlassController();
        });
      });
    };

    if (document.readyState === "complete") start();
    else window.addEventListener("load", start, { once: true });

    return () => {
      cancelled = true;
      window.removeEventListener("load", start);
      if (firstFrame !== null) window.cancelAnimationFrame(firstFrame);
      if (secondFrame !== null) window.cancelAnimationFrame(secondFrame);
      controller?.destroy();
    };
  }, []);

  return null;
}
